import { IconProps } from "./types";

export const CheckCircleIcon = ({
  size = 18,
  color = "currentColor",
  className,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7" cy="7" r="6.125" fill={color} fill-opacity=".2" />
    <path
      d="M6.173 9.087a.44.44 0 0 1-.31-.128l-1.65-1.65a.44.44 0 0 1 0-.62.44.44 0 0 1 .618 0l1.342 1.342L9.17 5.033a.44.44 0 0 1 .618 0c.17.17.17.45 0 .618L6.482 8.96a.44.44 0 0 1-.31.128"
      fill={color}
    />
  </svg>
);
